module.exports = __webpack_public_path__ + "img/pristine_fractal_relic.b499e6f3.png";